import { configureStore } from '@reduxjs/toolkit';
import { loadPersistedState, attachPersist } from './persist';
import authReducer from './slices/authSlice';
import jobsReducer from './slices/jobsSlice';
import companiesReducer from './slices/companiesSlice';
import templatesReducer from './slices/templatesSlice';
import encodersReducer from './slices/encodersSlice';
import encodingProfilesReducer from './slices/encodingProfilesSlice';
import usersReducer from './slices/usersSlice';
import websocketReducer from './slices/websocketSlice';
import dcpJobsReducer from './slices/dcpJobsSlice';
import dcpNodesReducer from './slices/dcpNodesSlice';
import kdmReducer from './slices/kdmSlice';
import venuesReducer from './slices/venuesSlice';
import deliveryReducer from './slices/deliverySlice';
import bookingsReducer from './slices/bookingsSlice';
import companyReducer from './slices/companySlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    company: companyReducer,
    jobs: jobsReducer,
    companies: companiesReducer,
    templates: templatesReducer,
    encoders: encodersReducer,
    encodingProfiles: encodingProfilesReducer,
    users: usersReducer,
    websocket: websocketReducer,
    dcpJobs: dcpJobsReducer,
    dcpNodes: dcpNodesReducer,
    kdm: kdmReducer,
    venues: venuesReducer,
    delivery: deliveryReducer,
    bookings: bookingsReducer,
  },
  // Stale-while-revalidate: hydrate the heavy slices from localStorage
  // on app boot so pages render last-known data immediately, then the
  // fetch thunks dispatched on mount swap in fresh data when it arrives.
  // See store/persist.js for the scope-by-user/company semantics.
  preloadedState: loadPersistedState(),
});

attachPersist(store);